export const globalSettingsIssuesWorkflowsSchemesEditRoute = {
	name: 'global-settings-issues-workflows-schemes-edit',
	path: '/secure/admin/EditWorkflowScheme.jspa',
};
